import { useCallback } from 'react';

import type { IngestionSection } from '@/services/types/case-ingestion-types';

import { useUnifiedFlow } from '../context/UnifiedFlowContext';

export const useResetIngestionSections = () => {
  const { updateSectionStatuses } = useUnifiedFlow();

  const resetSections = useCallback(
    async (sections: IngestionSection[]) => {
      if (sections.length === 0) return;

      const updates = sections.reduce<Partial<Record<IngestionSection, null>>>(
        (acc, section) => {
          acc[section] = null;
          return acc;
        },
        {},
      );

      await updateSectionStatuses(updates);
    },
    [updateSectionStatuses],
  );

  return { resetSections };
};
